<div class="w-100 mt-2 rounded rounded-8 panel">
  <p-panel [toggleable]="true"
           [style]="{width: '100%', marginBottom: '20px'}"
           expandIcon="pi pi-chevron-up"
           collapseIcon="pi pi-chevron-down">
    <ng-template pTemplate="header">
      <div class="w-100 bg-white br p-4" style="box-sizing: border-box;">
        <div class="d-flex align-items-center justify-content-between mb-4" style="height: 40px;">
          <div class="d-flex flex-row align-items-center justify-content-between w-50" style="height: 90%;">
            <div class="d-flex align-items-center" style="height: 100%;">
              <div class="left-border"></div>
              <span class="title">📊 Schema Drift List</span>
            </div>
            <span class="p-input-icon-left" style="height: 100%;">
              <i class="pi pi-search"></i>
              <input type="text" placeholder="Search by name of ID" class="search-input w-100" pInputText />
            </span>
          </div>
          <ng-container>
            <div class="row mb-2" style="padding-right:1.5rem;">
              <div class="col d-center">
                <div style="width: 130px;"
                     class="d-center gap-2 stats-container">
                  <span style="background-color:#CABDFF" class="d-center stats-icon">
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M6.74088 10.8335C9.13412 10.8335 11.0742 8.8934 11.0742 6.50016C11.0742 4.10693 9.13412 2.16683 6.74088 2.16683C4.34765 2.16683 2.40755 4.10693 2.40755 6.50016C2.40755 8.8934 4.34765 10.8335 6.74088 10.8335ZM6.74088 11.9168C9.73243 11.9168 12.1576 9.4917 12.1576 6.50016C12.1576 3.50862 9.73243 1.0835 6.74088 1.0835C3.74934 1.0835 1.32422 3.50862 1.32422 6.50016C1.32422 9.4917 3.74934 11.9168 6.74088 11.9168Z"
                            fill="black" />
                      <path d="M7.28223 4.33317C7.28223 4.03402 7.03971 3.7915 6.74056 3.7915C6.44141 3.7915 6.19889 4.03402 6.19889 4.33317L6.19889 5.95817H4.57389C4.27474 5.95817 4.03223 6.20068 4.03223 6.49984C4.03223 6.79899 4.27474 7.0415 4.57389 7.0415H6.19889V8.6665C6.19889 8.96566 6.44141 9.20817 6.74056 9.20817C7.03971 9.20817 7.28223 8.96566 7.28223 8.6665L7.28223 7.0415H8.90723C9.20638 7.0415 9.44889 6.79899 9.44889 6.49984C9.44889 6.20068 9.20638 5.95817 8.90723 5.95817H7.28223L7.28223 4.33317Z"
                            fill="black" />
                    </svg>
                  </span>
                  <span>Changes</span>
                  <span class="stats-count">{{ driftData.length }}</span>
                </div>
              </div>
              <div class="col d-center">
                <div style="width: 130px;"
                     class="d-center gap-2 stats-container">
                  <span style="background-color:#CABDFF" class="d-center stats-icon">
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M6.74088 10.8335C9.13412 10.8335 11.0742 8.8934 11.0742 6.50016C11.0742 4.10693 9.13412 2.16683 6.74088 2.16683C4.34765 2.16683 2.40755 4.10693 2.40755 6.50016C2.40755 8.8934 4.34765 10.8335 6.74088 10.8335ZM6.74088 11.9168C9.73243 11.9168 12.1576 9.4917 12.1576 6.50016C12.1576 3.50862 9.73243 1.0835 6.74088 1.0835C3.74934 1.0835 1.32422 3.50862 1.32422 6.50016C1.32422 9.4917 3.74934 11.9168 6.74088 11.9168Z"
                            fill="black" />
                      <path d="M7.28223 4.33317C7.28223 4.03402 7.03971 3.7915 6.74056 3.7915C6.44141 3.7915 6.19889 4.03402 6.19889 4.33317L6.19889 5.95817H4.57389C4.27474 5.95817 4.03223 6.20068 4.03223 6.49984C4.03223 6.79899 4.27474 7.0415 4.57389 7.0415H6.19889V8.6665C6.19889 8.96566 6.44141 9.20817 6.74056 9.20817C7.03971 9.20817 7.28223 8.96566 7.28223 8.6665L7.28223 7.0415H8.90723C9.20638 7.0415 9.44889 6.79899 9.44889 6.49984C9.44889 6.20068 9.20638 5.95817 8.90723 5.95817H7.28223L7.28223 4.33317Z"
                            fill="black" />
                    </svg>
                  </span>
                  <span>Archived</span>
                  <span class="stats-count">{{ lastDriftDate }}</span>
                </div>
              </div>
            </div>
          </ng-container>
          <button class="table-button"><span class="pi pi-filter"></span></button>
        </div>
      </div>
    </ng-template>

    <div class="w-100 bg-white br p-4" style="box-sizing: border-box;">
      <div class="d-flex flex-column scrollerbar">
        <div class="row w-100 mb-2 header-title">
          <div class="col-3 pointer" (click)="sortByColumn('table')">
            <p-checkbox [(ngModel)]="all" [binary]="true" class="header-checkbox"></p-checkbox>
            <span class="mx-4">Table Name</span>
            <span *ngIf="sortedColumn === 'table'" class="sorting-indicator">{{ sortAscending ? '▲' : '▼' }}</span>
          </div>
          <span class="col pointer d-center"
                (click)="sortByColumn('action')">
            Action
            <span *ngIf="sortedColumn === 'action'" class="sorting-indicator">{{ sortAscending ? '  ▲' : '  ▼' }}</span>
          </span>
          <span class="col pointer d-center"
                (click)="sortByColumn('column')">
            Column
            <span *ngIf="sortedColumn === 'column'" class="sorting-indicator">{{ sortAscending ? '  ▲' : '  ▼' }}</span>
          </span>
          <span class="col pointer d-center"
                (click)="sortByColumn('date')">
            Date
            <span *ngIf="sortedColumn === 'date'" class="sorting-indicator">{{ sortAscending ? '  ▲' : '  ▼' }}</span>
          </span>
        </div>
        <div class="hr mb-3 mt-2"></div>
        <ng-container *ngIf="!skeleton">
          <div class="row mb-2 py-2 {{row.isSelected ? 'content-card-active' : ''}}" style="padding-right:1.5rem;"
               *ngFor="let row of driftData">
            <div class="col-3 d-flex gap-4">
              <div>
                <p-checkbox [(ngModel)]="row.isSelected" [binary]="true"></p-checkbox>
              </div>
              <div class="d-flex w-100 align-items-center gap-4 content-title">
                <span class="content-title" [title]="row.table">{{row?.table}}</span>
                <div class="view-all hand-cursor" (click)="showTableData(row)">Quick View</div>
              </div>
            </div>
            <div class="col d-center">
              <div style="width: 130px;"
                   class="d-center gap-2 {{row.isSelected ? 'stats-container-active' : 'stats-container'}}">
                <span class="status-dot me-2"
                      [ngClass]="{
                                  'dot-added': row.action === 'Added',
                                  'dot-archived': row.action === 'Archived',
                                  'dot-removed': row.action === 'Removed'
                                }">
                </span>
                <span>{{row.action}}</span>
              </div>
            </div>
            <div class="col d-center">
              <div class="d-center gap-2 {{row.isSelected ? 'stats-container-active' : 'stats-container'}}">
                <span class="stats-count">{{row.column}}</span>
              </div>
            </div>
            <div class="col d-center">
              <div style="width: 130px;"
                   class="d-center gap-2 {{row.isSelected ? 'stats-container-active' : 'stats-container'}}">
                <!--<span class="stats-count">{{row.date | date:'yyyy-MM-dd HH:mm:ss':'UTC'}}</span>-->
                <span>{{row.date | date}}</span>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="skeleton">
          <div *ngFor="let my of [1,2,3]" class="row mb-2 py-2" style="padding-right:1.5rem;">
            <div class="col-3 d-flex gap-4">
              <div>
                <app-skeleton [skeleton]="{shape:'square', size:'1.5rem', count:[1]}"></app-skeleton>
              </div>
              <div class="d-flex w-100 align-items-center gap-4">
                <span class="content-title"><app-skeleton [skeleton]="{width: '150px', height:'1rem', count:[1]}"></app-skeleton></span>
              </div>
            </div>
            <div class="col" style="font-size: 14px;font-weight: 600;color: #6F767E;">
              <app-skeleton [skeleton]="{width: '150px', height:'1rem', count:[1]}"></app-skeleton>
            </div>
            <div class="col d-center" style="font-size: 15px;font-weight: 600;color: #1A1D1F;">
              <app-skeleton [skeleton]="{width: '50px', height:'1rem', count:[1]}"></app-skeleton>
            </div>
            <div class="col d-center">
              <div style="width: 130px;"
                   class="d-center gap-2">
                <span class="stats-count"><app-skeleton [skeleton]="{width: '140px', height:'1rem', count:[1]}"></app-skeleton></span>
              </div>
            </div>
            <div class="col d-center">
              <div style="width: 130px;"
                   class="d-center gap-2">
                <span class="stats-count"><app-skeleton [skeleton]="{width: '140px', height:'1rem', count:[1]}"></app-skeleton></span>
              </div>
            </div>
            <div class="col d-center">
              <div style="width: 130px;"
                   class="d-center gap-2">
                <span class="stats-count"><app-skeleton [skeleton]="{width: '140px', height:'1rem', count:[1]}"></app-skeleton></span>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="w-100 d-center mt-5 gap-4" style="box-sizing: border-box;">
          <span style="color: rgba(111, 118, 126, 0.50);" class="pi pi-arrow-left"></span>
          <p style="padding-top: 14px;align-self: center;text-align: center;color: rgba(111, 118, 126, 0.50);font-size: 15px;font-weight: 600;">
            1/1
          </p>
          <div class="d-center p-1" style="border:1px solid grey;border-radius: 50%;">
            <span class="pi pi-arrow-right"></span>
          </div>
        </div>
      </div>
      <div class="right-top" *ngIf="!isGridShow">
        <img class="mb-4" src="assets/images/svg/undraw_feeling.svg" />

        <h2 class="grey-black">You have not made any audit yet</h2>
        <span class="mb-4 grey-light">Click the button below to get started</span>

        <button class="primary">Create Audit</button>
      </div>
    </div>
  </p-panel>
</div>
